/*!
 * Built by Revolist OU ❤️
 */
export class ThemeMaterial {
    constructor() {
        this.defaultRowSize = 42;
    }
}
//# sourceMappingURL=theme.material.js.map
